import * as url from "../url_helper";

import { post } from "../api_helper";

export const getproductReport = data => post(url.GET_PRODUCT_REPORT, data);

export const getOrderRequestReport = data => post(url.GET_ORDER_REQUEST_REPORT, data);
export const getOrderReport = data => post(url.GET_ORDER_REPORT, data);

export const getdealerReport = data => post(url.GET_DEALER_REPORT, data);

export const getNewProductReport = data => post(url.GET_NEW_PRODUCT_REPORT, data)

export const getSalePerformanceReport = data => post(url.GET_SALE_PERFORMANCE_REPORT, data)

export const getZoneWiseSalesReport = data => post(url.GET_ZONE_WISE_SALES_REPORT, data)

export const getPlantWiseSalesReport = data => post(url.GET_PLANT_WISE_SALES_REPORT, data)

export const getAllRegion = data => post(url.GET_ALL_REGION, data)

export const getCustomerWiseSalesReport = data => post(url.GET_CUSTOMER_WISE_SALES_REPORT, data)

export const getTargetList = data => post(url.GET_TARGET_LIST, data)

export const getActualSale = data => post(url.GET_ACTUAL_SALE, data)

export const getActualSaleVsTarget = data => post(url.GET_ACTUAL_SALE_VS_TARGET, data)

export const getCreditLimit = data => post(url.GET_CREDIT_LIMIT, data)

export const getMTDSalesReport = data => post(url.GET_MTD_SALES_REPORT, data)

export const getLedgerReport = data => post(url.GET_LEDGER_REPORT, data)

export const getPendingOrderSalesReport = data => post(url.PENDING_ORDER_SALES_REPORT, data)

export const getMTDSalesReportSync = data => post(url.GET_MTD_SYNC, data)

export const getOrderSalesReportSync = data => post(url.GET_ORDER_SYNC, data)
